import { render } from "./applySave.vue?vue&type=template&id=6852d467&scoped=true"
import script from "./applySave.vue?vue&type=script&lang=js"
export * from "./applySave.vue?vue&type=script&lang=js"

import "./applySave.vue?vue&type=style&index=0&id=6852d467&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6852d467"]])

export default __exports__